import { render, staticRenderFns } from "./PageOperations.vue?vue&type=template&id=0304b328&scoped=true&"
import script from "./PageOperations.vue?vue&type=script&lang=js&"
export * from "./PageOperations.vue?vue&type=script&lang=js&"
import style0 from "./PageOperations.vue?vue&type=style&index=0&id=0304b328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0304b328",
  null
  
)

export default component.exports